export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="mb-10">
          <img
            src="/stp-logo.png"
            alt="Stellar Productions"
            className="h-10 w-10 object-contain mb-4"
          />
          <h1 className="text-3xl font-display font-bold text-gold mb-2">Privacy Policy</h1>
          <p className="text-sm text-muted-foreground">Last updated: February 2026</p>
        </div>

        <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">
          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">1. Introduction</h2>
            <p>Stellar Productions, a division of Regina Stellar Productions Ltd. ("we", "our", "us") operates the Stellar CRM platform. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our application. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the application.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">2. Information We Collect</h2>
            <p className="mb-2">We may collect information about you in a variety of ways, including:</p>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li><strong className="text-foreground">Personal Data:</strong> Name, email address, and login credentials you provide during registration.</li>
              <li><strong className="text-foreground">Social Media Data:</strong> When you connect your social media accounts (Facebook, Instagram, LinkedIn, Twitter/X, YouTube, Google Business), we access account information, page data, post analytics, and audience demographics as authorized by you through each platform's permissions.</li>
              <li><strong className="text-foreground">Content Data:</strong> Posts, images, videos, and other media you create or upload through the platform.</li>
              <li><strong className="text-foreground">Usage Data:</strong> Information about how you access and use the application, including device information, IP address, browser type, and usage patterns.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">3. How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-1 pl-2">
              <li>To provide and maintain our social media management services.</li>
              <li>To schedule, publish, and manage social media content on your behalf.</li>
              <li>To generate analytics, reports, and insights about your social media performance.</li>
              <li>To facilitate content approval workflows between team members and clients.</li>
              <li>To send administrative notifications about your account and service updates.</li>
              <li>To improve our application and develop new features.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">4. Third-Party Services</h2>
            <p>Our application integrates with third-party social media platforms including Meta (Facebook/Instagram), LinkedIn, Twitter/X, YouTube, Google Business, and others. When you connect these services, their respective privacy policies also apply. We encourage you to review the privacy policies of these platforms.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">5. Data Storage & Security</h2>
            <p>We implement appropriate technical and organizational security measures to protect your personal information. Your data is stored on secure servers and we use encryption for data in transit. Access to personal data is restricted to authorized personnel only.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">6. Data Retention</h2>
            <p>We retain your personal information for as long as your account is active or as needed to provide services. You may request deletion of your data at any time by contacting us.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">7. Your Rights</h2>
            <p>You have the right to access, correct, or delete your personal data. You may disconnect your social media accounts at any time, which will revoke our access to those platforms. To exercise any of these rights, please contact us.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">8. Data Deletion</h2>
            <p>You can request complete deletion of your data by contacting us at <a href="mailto:media@stellarproductions.ca" className="text-gold hover:underline">media@stellarproductions.ca</a>. Upon receiving a verified deletion request, we will delete your personal data within 30 days, except where we are required to retain it by law.</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-foreground mb-2">9. Contact Us</h2>
            <p>If you have questions or concerns about this Privacy Policy, please contact us at:</p>
            <p className="mt-2 text-foreground">
              <strong>Regina Stellar Productions Ltd.</strong><br />
              Email: <a href="mailto:media@stellarproductions.ca" className="text-gold hover:underline">media@stellarproductions.ca</a>
            </p>
          </section>
        </div>

        <div className="mt-12 pt-6 border-t border-border text-xs text-muted-foreground text-center">
          &copy; {new Date().getFullYear()} Regina Stellar Productions Ltd. All rights reserved.
        </div>
      </div>
    </div>
  );
}
